import React from 'react'
import { clsx } from 'clsx'

// Локальные статусы заказа синхронизированы с backend
// (app/core/order_status.py): 0 — неизвестно, 1 — доставляется,
// 2 — готов к доставке, 3 — готовится, 4 — новый, 5 — возврат,
// 6 — доставлен.
const STATUS_CONFIG: Record<number, { text: string; className: string }> = {
  0: { text: 'Неизвестно', className: 'bg-gray-100 text-gray-800' },
  1: { text: 'Доставляется', className: 'bg-primary-200 text-primary-900' },
  2: { text: 'Готов к доставке', className: 'bg-primary-100 text-primary-800' },
  3: { text: 'Готовится', className: 'bg-warning-50 text-warning-700' },
  4: { text: 'Новый', className: 'bg-primary-50 text-primary-700' },
  5: { text: 'Возврат', className: 'bg-error-50 text-error-700' },
  6: { text: 'Доставлен', className: 'bg-success-50 text-success-700' },
}

const UNKNOWN_CONFIG = {
  text: 'Неизвестно',
  className: 'bg-gray-100 text-gray-800',
}

export interface OrderStatusBadgeProps {
  status?: number | null
  // Подпись из API (`statusText`); если задана — показываем её
  statusText?: string | null
  className?: string
}

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
  status,
  statusText,
  className,
}) => {
  const config =
    status !== null && status !== undefined
      ? STATUS_CONFIG[status] ?? UNKNOWN_CONFIG
      : UNKNOWN_CONFIG

  const text = statusText?.trim() ? statusText : config.text

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.className,
        className
      )}
    >
      {text}
    </span>
  )
}
